<template>
    <v-container>
        <!-- ========================================================== -->
        <v-card>
            <v-card-title class="blue darken-2 pa-3">
                <h3 class="white--text">設定</h3>
            </v-card-title>
            <v-card-text>
                <v-btn to="/favorites" color="success" block class="my-16 pa-9">
                    <h2>お気に入り設定</h2>
                </v-btn>
                <v-btn to="/chart-setting" color="success" block class="my-16 pa-9">
                    <h2>グラフ設定</h2>
                </v-btn>
                <v-btn to="/user" color="success" block class="my-16 pa-9">
                    <h2>ユーザ設定</h2>
                </v-btn>
                <v-btn to="/mail-notify" color="success" block class="my-16 pa-9">
                    <h2>Mail通知設定</h2>
                </v-btn>
                <v-btn to="/logout" color="warning" block class="my-16 pa-9">
                    <h2>ログアウト</h2>
                </v-btn>
                <!--
                -->
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "Settings",
    components: {
        // colormap,
    },
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbUser: {},
        };
    },
    //#######################################################
    created: async function () {
        //====================================================
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //---------------------------
        this.axiosGetUsers();
        //---------------------------
        window.scrollTo(0, 0);
    },
    //#######################################################
    methods: {
        //====================================================
        async axiosGetUsers() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: { _fields: "id,name,permit" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                if (response.data.json[0]) {
                    this.dbUser = response.data.json[0];
                }
            });
        },
        //====================================================
    },
    //#######################################################
};
</script>
